//#region common/constants/index.js
var e = typeof HTMLElement < "u" ? HTMLElement : Object, t = {
	ERROR: "error",
	WARNING: "warning",
	SUCCESS: "success"
}, n = {
	LARGE: "lg",
	EXTRA_LARGE: "xl"
}, r = {
	xs: "",
	sm: "",
	md: "",
	lg: "d-description--lg",
	xl: "d-description--xl"
}, i = {
	xs: "d-label--xs",
	sm: "d-label--sm",
	md: "",
	lg: "d-label--lg",
	xl: "d-label--xl"
}, a = {
	esc: "Esc",
	escape: "Escape",
	tab: "Tab",
	enter: "Enter",
	space: "Space",
	spacebar: "Spacebar",
	up: "Up",
	arrowup: "ArrowUp",
	left: "Left",
	arrowleft: "ArrowLeft",
	right: "Right",
	arrowright: "ArrowRight",
	down: "Down",
	arrowdown: "ArrowDown",
	home: "Home",
	end: "End"
}, o = t.ERROR, s = "dt", c = {
	VALIDATION_MESSAGE_TYPES: t,
	DESCRIPTION_SIZE_TYPES: n,
	DEFAULT_VALIDATION_MESSAGE_TYPE: o,
	DEFAULT_PREFIX: "dt"
};
//#endregion
export { s as DEFAULT_PREFIX, o as DEFAULT_VALIDATION_MESSAGE_TYPE, r as DESCRIPTION_SIZE_MODIFIERS, n as DESCRIPTION_SIZE_TYPES, a as EVENT_KEYNAMES, e as HTML_ELEMENT_TYPE, i as LABEL_SIZE_MODIFIERS, t as VALIDATION_MESSAGE_TYPES, c as default };

//# sourceMappingURL=index.js.map